import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Achievement = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="py-12 font-titleFont flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      <div>
        <div className="py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">
            Automation & Quality Engineering
          </p>
          <h2 className="text-4xl font-bold">Achievements</h2>
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Test Automation Frameworks"
            subTitle="Playwright · Cypress · Selenium · Appium"
            result="Impact"
            des="Designed and maintained scalable automation frameworks for web and mobile apps, improving test reliability, maintainability, and cross-team adoption."
          />
          <ResumeCard
            title="API & Integration Testing"
            subTitle="REST APIs · Postman · Contract Validation"
            result="Quality"
            des="Implemented API-level automation strategies to validate business rules and integrations, enabling early defect detection and reducing downstream failures."
          />
          <ResumeCard
            title="CI/CD Quality Gates"
            subTitle="Jenkins · GitHub Actions · Azure DevOps"
            result="Speed"
            des="Integrated automated tests into CI/CD pipelines, enforcing quality gates that accelerated releases without compromising product stability."
          />
        </div>
      </div>

      <div>
        <div className="py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">
            Performance, Reliability & Leadership
          </p>
          <h2 className="text-4xl font-bold">Highlights</h2>
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Performance Testing Strategy"
            subTitle="K6 · JMeter · Grafana"
            result="Reliability"
            des="Defined and executed performance testing strategies to validate scalability, response times, and stability under load in critical environments."
          />
          <ResumeCard
            title="Quality Leadership & Collaboration"
            subTitle="Agile Teams · Cross-functional Work"
            result="Ownership"
            des="Partnered closely with developers and product stakeholders to embed quality throughout the SDLC and improve delivery confidence."
          />
          <ResumeCard
            title="Teaching & Mentoring"
            subTitle="University-level QA Automation Courses"
            result="Growth"
            des="Designed and taught test automation courses, mentoring engineers in modern QA practices and automation best practices."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Achievement;